var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparxLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 907.45 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 332.17,
    y1: 210.42,
    x2: 477.82,
    y2: 87.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#652092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f54de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ff83b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffad83"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m0,168.9l9.43-10.83c21.38,19.72,41.09,28.89,69.69,28.89s49.15-16.39,49.15-38.62v-.55c0-20.57-10.83-32.5-54.98-41.39C26.66,96.96,7.77,81.12,7.77,51.67v-.55C7.77,22.21,34.15,0,70.26,0,98.58,0,117.18,7.77,136.91,23.61l-9.16,11.38c-18.32-15.84-36.66-21.94-58.04-21.94-28.6,0-47.49,16.39-47.49,36.68v.55c0,20.57,10.55,33.07,56.65,42.5,44.97,9.16,63.86,25.27,63.86,53.61v.55c0,31.4-26.93,53.06-64.41,53.06-31.09,0-54.98-10.28-78.3-31.1h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m200.48,111.75V16.46h54.98c34.99,0,58.86,16.11,58.86,46.94v.55c0,28.89-24.44,47.78-60.53,47.78h-32.08v13.32h31.26c40.54,0,75.81-21.12,75.81-61.95v-.55c0-37.5-29.44-59.44-72.2-59.44h-70.53v194.47h14.44v-72.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m560.5,103.96V16.46h66.35c35.27,0,55.8,16.39,55.8,42.5v.55c0,28.06-24.17,44.45-56.65,44.45h-44.17v13.05h42.23l61.92,80.55h18.32l-64.14-83.07c32.76-4.44,56.92-23.06,56.92-55.55v-.55c0-13.89-5.55-26.94-14.71-36.11-11.67-11.68-30.81-19.17-54.7-19.17h-81.63v194.47h14.44v-80.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m812.45,98.39L738.06,3.12h17.22l66.35,85.83L887.71,3.12h16.95l-74.69,95.29,77.48,99.18h-17.22l-69.14-89.72-68.87,89.72h-16.95l77.18-99.18v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m415.87,31.72l74.72,151.85h-149.63L415.87,31.72m.02-31.72l-97.47,197.59h194.7L415.89,0h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparxLogoFooter);
export default __webpack_public_path__ + "static/media/sparx-logo-footer.a65eb077227dd999c09ee3054648ef20.svg";
export { ForwardRef as ReactComponent };